import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  templateStylePreferences: [],
  isTemplateStylePreferencesLoading: false,
};

const memorySlice = createSlice({
  name: 'memorySlice',
  initialState,
  reducers: {
    templateStylePreferencesLoading: (state, { payload }) => {
      state.isTemplateStylePreferencesLoading = payload;
    },
    templateStylePreferencesSlice: (state, { payload }) => {
      state.templateStylePreferences = payload;
    },
  },
});

const { actions, reducer } = memorySlice;

export const {
  templateStylePreferencesLoading,
  templateStylePreferencesSlice,
} = actions;

export default reducer;
